export const categoryIconList: {[key: number]: string} = {
    1: 'speaker',
    2: 'tours',
    3: 'cake',
    4: 'arts',
    5: 'conventions',
    6: 'ball',
    7: 'smilingFace',
    17: 'fundraiser',
    49: 'sunHat',
    0: 'generalMenu',
    949: 'shows',
    950: 'childrenShows',
    951: 'concert',
    952: 'lecture'
};

